export const TopPartElement = (p: {
  icon: React.ReactNode;
  onClick?: () => void;
  children: any;
}) => {

  return (
    <a
      href={""}
      className={"bg-white rounded-2xl w-full"}
      style={{
        boxShadow: "rgb(80 80 80 / 100%) 0px 5px 15px"
      }}
      onClick={(ev) => {
        ev.preventDefault();
        p.onClick != null && p.onClick();
      }}
    >
      <div className="p-4 text-black flex-col flex items-center gap-1">
        {p.icon}
        <div
          className={
            "flex-1 flex flex-col justify-center items-center align-center"
          }
        >
          {p.children}
        </div>
      </div>
    </a>
  );
};